import { gql } from "@apollo/client";

export const QUERY_ATTACK_MODE_DATA = gql`
  query getAttackModeData {
    getAttackModeData {
      attackModeStates {
        driver
        attackModeState {
          attackScenario
          attackActivations {
            startTime
            endTime
            lap
          }
          attacksRemainingLive
        }
      }
      attackLosses {
        participant
        participantBehind
        lap
        gap
        keptPosition
        behindInAttack
      }
    }
  }
`;

export const SUBSCRIBE_ATTACK_MODE_DATA = gql`
  subscription newAttackModeData {
    newAttackModeData {
      attackModeStates {
        driver
        attackModeState {
          attackScenario
          attackActivations {
            startTime
            endTime
            lap
          }
          attacksRemainingLive
        }
      }
      attackLosses {
        participant
        participantBehind
        lap
        gap
        keptPosition
        behindInAttack
      }
    }
  }
`;

export const SUBSCRIBE_DRIVER_ATTACK_MODE_STATE_UPDATE = gql`
  subscription newDriverAttackModeStateUpdate {
    newDriverAttackModeStateUpdate {
      driver
      attackModeState {
        attackScenario
        attackActivations {
          startTime
          endTime
          lap
        }
        attacksRemainingLive
      }
    }
  }
`;

export const SUBSCRIBE_ATTACK_LOSS_UPDATE = gql`
  subscription newAttackLossUpdate {
    newAttackLossUpdate {
      participant
      participantBehind
      lap
      gap
      keptPosition
      behindInAttack
    }
  }
`;
